// context/OrganizationContext.js
import { createContext, useContext, useState } from "react";

const OrganizationSelectContext = createContext();

export const OrganizationSelectProvider = ({ children }) => {
  const [selectedOrganization, setSelectedOrganization] = useState(null);

  return (
    <OrganizationSelectContext.Provider value={{ selectedOrganization, setSelectedOrganization }}>
      {children}
    </OrganizationSelectContext.Provider>
  );
};

export const useOrganizationSelect = () => useContext(OrganizationSelectContext);
